export const namespace = "mode/";
export const SET_MODE = "SET_MODE";
export const SET_MODE_TRANSITION = "SET_MODE_TRANSITION";


export const MODE_TOP = "MODE_TOP";
export const MODE_AREA = "MODE_AREA";
export const MODE_TUTORIAL = "MODE_TUTORIAL";
export const MODE_DRAW = "MODE_DRAW";
export const MODE_PUBLISH = "MODE_PUBLISH";
export const MODE_END = "MODE_END";
